import styled from 'styled-components';
import { Button } from 'antd';

// Mirrors SAssigneeTriggerButton so the empty Due Date "Add" affordance
// matches the Assignee column (Figma node-id 35728-325457).
export const SDueDateTriggerButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  height: auto;
  text-align: left;
  color: #808080;
  background: transparent;
  border: none;
  box-shadow: none;
  &:hover,
  &:focus {
    background: transparent;
  }
`;
